import * as React from 'react';
import { Pill } from '../../Pill/pill';
import { Dropbox } from '../../Dropbox/dropbox';
import { useActions } from '../viewActions';
import { useSelector } from '../../../utils/useSelector';
import { DownArrow } from '../../Icon/icon';
import { EFSCompanyDirectionId } from '../../../enums/EFSCompanyDirectionId';
import { EFSExperienceId } from '../../../enums/EFSExperienceId';
import { useActions as useEFSActions } from './EFSEditMode/EFSEditModeActions';

export const EFSPersona = () => {
  const { setEFSPersona } = useEFSActions();
  const selectedEFSPersona = useSelector(s => s.view?.selectedEFSPersona) || {
    efsCompanyDirectionId: EFSCompanyDirectionId.MaintainDirection,
    efsExperienceId: EFSExperienceId.FirstTime
  };

  const options = [
    {
      displayName: 'First Time, Maintain Direction',
      value: {
        efsCompanyDirectionId: EFSCompanyDirectionId.MaintainDirection,
        efsExperienceId: EFSExperienceId.FirstTime
      }
    },
    {
      displayName: 'First Time, Change Direction',
      value: {
        efsCompanyDirectionId: EFSCompanyDirectionId.ChangeDirection,
        efsExperienceId: EFSExperienceId.FirstTime
      }
    },
    {
      displayName: 'Experienced, Maintain Direction',
      value: {
        efsCompanyDirectionId: EFSCompanyDirectionId.MaintainDirection,
        efsExperienceId: EFSExperienceId.Experienced
      }
    },
    {
      displayName: 'Experienced, Change Direction',
      value: {
        efsCompanyDirectionId: EFSCompanyDirectionId.ChangeDirection,
        efsExperienceId: EFSExperienceId.Experienced
      }
    }
  ];
  const defaultPersona = {
    efsCompanyDirectionId: EFSCompanyDirectionId.MaintainDirection,
    efsExperienceId: EFSExperienceId.FirstTime
  };

  const selectedDisplayName = options.find(
    option =>
      option.value.efsCompanyDirectionId ===
        (selectedEFSPersona?.efsCompanyDirectionId ||
          defaultPersona.efsCompanyDirectionId) &&
      option.value.efsExperienceId ===
        (selectedEFSPersona?.efsExperienceId || defaultPersona.efsExperienceId)
  )?.displayName;

  return (
    <div>
      <Dropbox
        className="efs-persona-dropbox"
        renderBox={() => (
          <div className="efs-persona-options">
            {options.map(option => (
              <div
                key={option.displayName}
                className="efs-persona-option"
                onClick={() => setEFSPersona(option.value)}
              >
                <Pill name={option.displayName} />
              </div>
            ))}
          </div>
        )}
        position="right"
      >
        <Pill name={selectedDisplayName} isSelected={true} />
        <DownArrow />
      </Dropbox>
    </div>
  );
};
